
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppFileUpload, AppSwitch } from '@/components';
import { AppButton } from '@/components';
import { useStarterPackAdd } from '@/modules/starter/pack/model/add';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppFileUpload, AppCard, AppButton, AppSwitch },
    setup() {
        const { model, v$, actions, iapOptions } = useStarterPackAdd();

        return { v$, model, actions, iapOptions };
    }
});
